module.exports = __webpack_public_path__ + "static/img/introduce_12.1e582d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_12.png
// module id = jfPJ
// module chunks = 1